import { render, staticRenderFns } from "./SideCart.vue?vue&type=template&id=2d4a284c&"
import script from "./SideCart.vue?vue&type=script&lang=js&"
export * from "./SideCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports